<template>
  <div class="authWrapper new-login-wrapper rest-password-container">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <router-link to="/verify-identity">
              <h6 class="login-highlight">Back</h6>
            </router-link>
            <div class="rep-icon-login">
              <img src="../../assets/images/dashboard-rep.svg" alt="Rep Icon" />
            </div>
            <h4 class="login-title mb-2">Reset Password</h4>
            <div class="auth-form pt-1 pb-3">
              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(changePassword)">
                  <!-- New Password -->
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required|strong_password"
                    name="New Password"
                    vid="newpassword"
                  >
                    <b-form-group
                      label="New Password"
                      label-for="input-1"
                      :state="errors.length || formErrorFlag ? false : null"
                    >
                      <div class="changeForm-group errorIcon_eye position-relative">
                        <b-form-input
                          autocomplete="new-password"
                          class="no-bg-icon"
                          id="input-1"
                          :type="newPasswordType"
                          v-model="newpassword"
                          :state="errors.length || formErrorFlag ? false : null"
                          placeholder="Enter your new password"
                          @input="onPasswordInput"
                          aria-label="New Password"
                        />
                        <eye-button
                          id="input-1"
                          :hideOnDefault="true"
                          :value="newpassword"
                          className="rest-toggle-eye-icon"
                          type="text"
                          @toggle="toggleNewPasswordVisibility"
                        />
                        <b-form-invalid-feedback>
                          <div>{{ errors[0] || (formErrorFlag ? formErrors.error : '') }}</div>
                        </b-form-invalid-feedback>
                      </div>
                    </b-form-group>
                  </ValidationProvider>

                  <!-- Strength Bar -->
                  <b-form-group>
                    <password-strength-bar
                      @updateScore="setPasswordScore"
                      :password="newpassword"
                    />
                  </b-form-group>

                  <!-- Confirm Password -->
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required|confirmed:newpassword"
                    name="Re-Type New Password"
                  >
                    <b-form-group
                      label="Re-Type New Password"
                      label-for="input-2"
                      :state="errors.length || formErrorFlag ? false : null"
                    >
                      <div
                        class="changeForm-group position-relative"
                        :class="errors.length || formErrorFlag ? 'errorIcon_eye' : ''"
                      >
                        <b-form-input
                          autocomplete="new-password"
                          class="no-bg-icon"
                          id="input-2"
                          :type="reTypePasswordType"
                          :state="errors.length || formErrorFlag ? false : null"
                          v-model="confirmpassword"
                          placeholder="Re-Type New Password"
                          aria-label="Re-Type Password"
                        />
                        <eye-button
                          id="input-2"
                          :hideOnDefault="true"
                          :value="confirmpassword"
                          className="rest-toggle-eye-icon"
                          type="text"
                          @toggle="toggleReTypePasswordVisibility"
                        />
                        <b-form-invalid-feedback>
                          <div>{{ errors[0] || (formErrorFlag ? formErrors.error : '') }}</div>
                        </b-form-invalid-feedback>
                      </div>
                    </b-form-group>
                  </ValidationProvider>

                  <!-- Submit Button -->
                  <button
                    :disabled="verifyLoader || !newpassword || !confirmpassword"
                    class="submit-btn mt-3 next-btn"
                    type="submit"
                  >
                    <b-spinner v-if="verifyLoader" small></b-spinner>
                    Change Password
                  </button>
                </b-form>
              </ValidationObserver>
            </div>
          </div>
        </div>

        <!-- Right Side Image Carousel -->
        <div class="col-lg-5 col-md-5 no-padding">
          <Logincarsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logincarsoule from "./Logincarsoule";
import EyeButton from "./EyeButton.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import helper from "@/resource/Helper";
import { extend } from "vee-validate";
import { required, confirmed } from "vee-validate/dist/rules";

extend("strong_password", {
  validate: (value) => {
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    return value.length >= 8 && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;
  },
  message: "Password should be at least 8 characters long and include uppercase, lowercase, number & special character.",
});

extend("required", required);
extend("confirmed", confirmed);

export default {
  name: "ResetPassword",
  components: {
    Logincarsoule,
    EyeButton,
  },
  data() {
    return {
      newpassword: "",
      confirmpassword: "",
      formErrorFlag: false,
      formErrors: { error: "" },
      verifyLoader: false,
      passwordScore: 0,
      newPasswordType: "password",
      isNewPasswordVisible: true,
      reTypePasswordType: "password",
      isReNewPasswordVisible: true,
    };
  },
  computed: {
    ...mapGetters({
      deviceId: "deviceId",
      loginOtpSource:"loginOtpSource",
      storeEmail:'repEmail',
      verifiedIdentitySelectedInfo: "verifiedIdentitySelectedInfo",
      otp: "OTPCode",
    }),

    email(){
      return this.loginOtpSource=="login"
      ?this.storeEmail
      :this.verifiedIdentitySelectedInfo.email;
    }
  },
  methods: {
    toggleNewPasswordVisibility() {
      this.isNewPasswordVisible = !this.isNewPasswordVisible;
      this.newPasswordType = this.isNewPasswordVisible ? "text" : "password";
    },
    toggleReTypePasswordVisibility() {
      this.isReNewPasswordVisible = !this.isReNewPasswordVisible;
      this.reTypePasswordType = this.isReNewPasswordVisible ? "text" : "password";
    },
    setPasswordScore(score) {
      this.passwordScore = score;
    },
    onPasswordInput() {
      this.$refs.observer.validate(); // Trigger validation on input
      if (this.formErrorFlag && this.$refs.observer.errors["New Password"].length === 0) {
        this.resetErrorMsg();
      }
    },
    resetErrorMsg() {
      this.formErrorFlag = false;
      this.formErrors.error = "";
    },
    async changePassword() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid || this.passwordScore < 60) {
        this.formErrorFlag = true;
        this.formErrors.error =
          this.$refs.observer.errors["New Password"][0] ||
          this.$refs.observer.errors["Re-Type New Password"][0] ||
          "Password should be at least 8 characters long and include uppercase, lowercase, number & special character.";
        return;
      }

      this.verifyLoader = true;
      const url = this.$endpoint.API_V4_RESET_PASSWORD;

      axios
        .post(url, {
          password: this.newpassword,
          reset_code: this.otp,
          email: this.email,
          device_id: this.deviceId,
        })
        .then((response) => {
          if (response.data.status === "success") {
            helper.infoMessage(this, response.data.status, response.data.message);
            helper.delayRedirect("Login", 0);
          }
        })
        .catch((error) => {
          const errData = error.response?.data;
          helper.infoMessage(
            this,
            errData?.status || "error",
            errData?.message || "Something went wrong"
          );
        })
        .finally(() => {
          this.verifyLoader = false;
        });
    },
  },
  created() {
    if (!this.email || !this.otp) {
      this.$router.push({ name: "ForgotPassword" });
      this.$toasted?.error("Session expired. Please try again.");
    }
  },
};
</script>

<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
.rep-icon-login img {
  width: 100px;
}
.rest-password-container .invalid-feedback {
  color: #e73737;
  background-color: #ffe9e9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}
.rest-password-container .error-message {
  color: #e73737;
  background-color: #ffe9e9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}
</style>

<style scoped>
.no-bg-icon {
  background: none !important;
}
.rest-toggle-eye-icon {
  position: absolute;
  top: 10px;
  right: 8px;
  cursor: pointer;
}
</style>